export default function AppEntry() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="rounded-2xl bg-background-100 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-8 p-6 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                随时随地 · 手机观影
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-lg">
                7788电影网全面适配移动端，无需下载APP，打开浏览器即可享受与电脑端一致的<strong className="text-foreground-900">高清流畅播放</strong>体验。
                支持iOS和Android系统，走到哪看到哪，电影随时随地陪伴你。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  立即体验
                </a>
                <a
                  href="#faq"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-foreground-200 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <i className="ri-question-line"></i>
                  了解更多
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-48 h-64 md:w-56 md:h-72 rounded-2xl overflow-hidden ring-4 ring-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20clean%20movie%20streaming%20interface%20with%20film%20posters%20and%20warm%20dark%20theme%2C%20minimal%20UI%20design%2C%20cinematic%20color%20palette%20with%20crimson%20and%20gold%20accents%2C%20sleek%20device%20on%20warm%20background&width=400&height=700&seq=app-mobile-preview&orientation=portrait"
                  alt="7788电影网移动端观影界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}